import React, { createContext, useContext, useState, useEffect } from "react";
import api from "./api";
import { secureClear } from "./secureStore";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mfp_token");
    const cached = localStorage.getItem("mfp_user");
    if (token && cached) {
      setUser(JSON.parse(cached));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mfp_token", data.token);
    localStorage.setItem("mfp_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("mfp_token", data.token);
    localStorage.setItem("mfp_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    localStorage.removeItem("mfp_token");
    localStorage.removeItem("mfp_user");
    await secureClear();
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
